


























// vendor
import { defineComponent, computed, ref } from "@vue/composition-api";
// project
import { useTranslate } from "@/plugins/translate";

export default defineComponent({

	setup(props, context){
		
		const { translate } = useTranslate(context);

		const titleText = computed(() => {
			return translate("study_participateInStudy");
		})

		const buttonText = computed(() => {
			return translate("start").toUpperCase();
		});
		
		return {
			titleText,
			buttonText
		};
	}
});

